import CartboxPriceViewSwitcher from './CartboxPriceViewSwitcher'
import cartboxPriceViewSwitcherContainer from './cartboxPriceViewSwitcherContainer'

export default cartboxPriceViewSwitcherContainer(CartboxPriceViewSwitcher)
